import type { ScorecardKpiStatus } from '@/services/scorecard.service'

/** What Scorecard pickers offer. On Hold is set from OGSM, so it is not here. */
export const SCORECARD_STATUS_OPTIONS: ScorecardKpiStatus[] = [
  'ON_TRACK',
  'AT_RISK',
  'OFF_TRACK',
  'ACHIEVED',
  'NOT_STARTED',
]

const SCORECARD_STATUS_LABELS: Record<ScorecardKpiStatus, string> = {
  NOT_STARTED: 'Not Started',
  ON_TRACK: 'On Track',
  AT_RISK: 'At Risk',
  OFF_TRACK: 'Off Track',
  ACHIEVED: 'Achieved',
  ON_HOLD: 'On Hold',
}

/** The picker options for a KPI: its current status stays listed even when Scorecard does not offer it. */
export function scorecardStatusOptionsFor(
  current: ScorecardKpiStatus | undefined
): ScorecardKpiStatus[] {
  if (!current || SCORECARD_STATUS_OPTIONS.includes(current))
    return SCORECARD_STATUS_OPTIONS
  return [...SCORECARD_STATUS_OPTIONS, current]
}

export function isScorecardKpiStatus(
  value: string
): value is ScorecardKpiStatus {
  return Object.hasOwn(SCORECARD_STATUS_LABELS, value)
}

export function formatScorecardStatusLabel(status: ScorecardKpiStatus): string {
  return SCORECARD_STATUS_LABELS[status]
}

export function getScorecardStatusOptionLabel(
  status: ScorecardKpiStatus
): string {
  return formatScorecardStatusLabel(status)
}
